export function formatNumberAsCurrency(num: number) {
  return num ? num.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
  }) : '$0';
}